import {
  useTroubleshootReferenceResolutions,
} from "../../utils/ticket/TicketTroubleshootRefrences";

export default function TroubleshootResolutionSelect({
  causeId,
  value,
  onChange,
  manualValue,
  onManualChange,
  required,
  disabled,
}) {
  const { data: resolutions, loading } = useTroubleshootReferenceResolutions(causeId);
  const showManual = value && resolutions.find((res) => res.id === value)?.manual_input;

  return (
    <div className="form-group">
      <label>Solusi {required && <span className="text-danger">*</span>}</label>
      <select
        className="form-control"
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
      >
        <option value="">-- Pilih Solusi --</option>
        {loading ? (
          <option>Loading...</option>
        ) : (
          resolutions.map((res) => (
            <option key={res.id} value={res.id}>
              {res.name}
            </option>
          ))
        )}
      </select>
      {showManual && (
        <input
          type="text"
          className="form-control mt-2"
          value={manualValue}
          onChange={onManualChange}
          placeholder="Masukkan solusi manual..."
          required
        />
      )}
    </div>
  );
}
